import { render, staticRenderFns } from "./ERP-short-message-warning-modal.vue?vue&type=template&id=6ad508f0&scoped=true"
import script from "./ERP-short-message-warning-modal.vue?vue&type=script&lang=js"
export * from "./ERP-short-message-warning-modal.vue?vue&type=script&lang=js"
import style0 from "./ERP-short-message-warning-modal.vue?vue&type=style&index=0&id=6ad508f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad508f0",
  null
  
)

export default component.exports